'use client';

import { useState, useRef, useEffect } from 'react';
import { ScrollTrigger } from 'gsap/all';
import { gsap } from 'gsap';
import AccordionStyle from "@/components/common/Accordion/style";

export default function Accordion({ items = [] }) {
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef({});
  const itemRefs = useRef({});
  const scrollTriggers = useRef([]);

  const toggle = (index) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  // Animate each FAQ item on scroll
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    items.forEach((item, index) => {
      const itemRef = itemRefs.current[index];
      if (itemRef) {
        const trigger = ScrollTrigger.create({
          trigger: itemRef,
          start: 'top 90%',
          end: 'top top',
          once: true,
          onEnter: () => {
            gsap.fromTo(
              itemRef,
              { opacity: 0, y: 50 },
              { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out', delay: index * 0.1 }
            );
          },
        });
        scrollTriggers.current.push(trigger);
      }
    });

    return () => {
      scrollTriggers.current.forEach(trigger => {
        if (trigger) trigger.kill();
      });
      scrollTriggers.current = [];
    };
  }, [items]);

  return (
    <AccordionStyle>
      <div className="faq-accordion">
        {items.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div 
              key={item.id} 
              ref={(el) => {
                itemRefs.current[index] = el;
              }}
              className="faq-item border-b border-gray-300 py-4"
              style={{ opacity: 0 }}>
              <button
                onClick={() => toggle(index)}
                className="faq-question w-full text-left flex justify-between items-center"
              >
                <span className="font-semibold text-lg">{item.question}</span>

                <span className="faq-icon text-xl font-bold">
                  {isOpen ? '−' : '+'}
                </span>
              </button>

              <div
                ref={(el) => (contentRefs.current[index] = el)}
                className="faq-content overflow-hidden transition-all duration-300"
                style={{
                  maxHeight: isOpen
                    ? `${contentRefs.current[index]?.scrollHeight}px`
                    : '0px',
                  opacity: isOpen ? 1 : 0,
                }}
              >
                <div
                  className="faq-answer pt-3 pb-3 text-gray-700"
                  dangerouslySetInnerHTML={{ __html: item.answer }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </AccordionStyle>
  );
}
